import React from 'react';
import i18n from '../../i18n/i18n';
import axios from '../../utils/AxiosWrapper';
import styles from './OpstinaWeather.module.css';
import moment from 'moment';
import { MoonLoader } from 'react-spinners';
import { LinearProgress } from '@material-ui/core';
import { Degrees } from '../../utils/Degrees';
import NavigationIcon from '@material-ui/icons/Navigation';
import { zoomFormat } from './../Maps/ZoomAndCenter';
import vp from './../../assets/images/vp1.png';
import { formatForecast } from '../sensor/DataFormatters';
import { Bar } from 'react-chartjs-2';

const today = moment().format('YYYY-MM-DD');
const packageName = 'basic-day';
const apiKey = 'OUP4p7JqGlARwkMF';


export default class OpstinaWeather extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            weather: {},
            stations: [],
            selectedStation: {},
            forecast: {},
            loading: true,
        };
    }
    componentDidMount() {
        this.getStations()
    }

    getStations = () => {
        axios.get('api/sensor/read_by_opstina')
            .then(res => {
                this.setState(
                    {
                        stations: res.data,
                        selectedStation: res.data[0] || {}
                    },
                    () => {
                        if (this.state.selectedStation.uid) {
                            this.getForecast(this.state.selectedStation.uid);
                        }
                    }
                );
            })
            .catch(err => console.log(err));
    }


    getForecast = (uid) => {
        axios.post('/api/testMeteo/meteo', { path: `/forecast/${uid}/hourly`, method: "POST", name: 'general3' })
            .then(res => { let obj = formatForecast(res); this.setState({ forecast: obj, load: false }); })
            .catch(err => console.log('Error: ', err))
        console.log(this.state.forecast)



    }
    getWeatherData = async () => {

        //     axios.post('api/testMeteo/forecast', {
        //         uid: '002104A6'
        //     }).then(res => {
        //         this.setState({ weather: res.data });
        //     }).catch(err => console.log('Error: ', err))
    }

    render() {
        let graph1 = {};
        if (
            this.state.forecast.dates !== undefined
        ) {
            graph1 = {
                labels: this.state.week ? this.state.forecast.dates : this.state.forecast.dates.slice(0, 72),
                datasets: [
                    {
                        data: this.state.week ? this.state.forecast.temperature : this.state.forecast.temperature.slice(0, 72),
                        label: i18n.t('Temperature [°C]'),
                        backgroundColor: 'transparent',
                        borderColor: 'red',
                        type: 'line',
                        borderWidth: 2,
                        pointRadius: 2,
                        pointBackgroundColor: 'red',
                        yAxisID: 'y-axis-2',
                    },
                    {
                        data: this.state.week ? this.state.forecast.relativehumidity : this.state.forecast.relativehumidity.slice(0, 72),
                        label: i18n.t('Humidity [%]'),
                        type: 'line',
                        backgroundColor: 'transparent',
                        borderColor: 'rgb(75, 153, 204)',
                        borderWidth: 2,
                        pointRadius: 2,
                        pointBackgroundColor: 'rgb(75, 153, 204)',
                        yAxisID: 'y-axis-1',
                    },
                    {
                        data: this.state.week ? this.state.forecast.precipitation : this.state.forecast.precipitation.slice(0, 72),
                        label: i18n.t('Precipitation [mm]'),
                        backgroundColor: 'rgba(134,184,217,0.3)',
                        borderColor: '#063e63ff',
                        type: 'line',
                        backgroundColor: 'transparent',
                        borderWidth: 2,
                        pointRadius: 2,
                        pointBackgroundColor: '#86b8d9',
                        yAxisID: 'y-axis-3',
                    },
                    {
                        data: this.state.week ? this.state.forecast.windspeed : this.state.forecast.windspeed.slice(0, 72),
                        label: i18n.t('Wind speed [m/s]'),
                        borderColor: 'rgba(39, 43, 45, 1)',
                        type: 'line',
                        borderWidth: 2,
                        backgroundColor: 'transparent',

                        pointRadius: 2,
                        yAxisID: 'y-axis-4',
                    },
                ],
            };
        }
        const options1 = {
            scales: {
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-1',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[%]'
                        },
                        ticks: {
                            // beginAtZero: true,
                            min: 30,
                            max: 100,
                        }
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-2',
                        gridLines: {
                            drawOnChartArea: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[°C]'
                        },
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-3',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[mm]'
                        },
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            max: 10,
                        }
                    },
                    {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        id: 'y-axis-4',
                        gridLines: {
                            drawOnChartArea: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[m/s]'
                        },
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            // max: 100,
                        }
                    },
                ],
            },

        };
        let weatherData;
        if (this.state.weather) {
            weatherData = this.state.weather
        }

        return (
            <div className={styles.container}>
                {/* Styled select dropdown for meteo stations */}
                <div style={{ marginBottom: '20px', width: '300px', overflow: 'hidden' }}>
                    <label htmlFor="station-select" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#4FA2CD', fontSize: '16px' }}>
                        {i18n.t('Meteo stations')}:
                    </label>
                    <select
                        id="station-select"
                        value={this.state.selectedStation && this.state.selectedStation.uid ? this.state.selectedStation.uid : ''}
                        onChange={e => {
                            const selected = this.state.stations.find(st => st.uid === e.target.value);
                            this.setState({ selectedStation: selected || {} }, () => {
                                if (selected && selected.uid) {
                                    this.getForecast(selected.uid);
                                }
                            });
                        }}
                        style={{
                            width: '100%',
                            padding: '8px 12px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            fontSize: '15px',
                            background: '#f8fafd',
                            color: '#333',
                            outline: 'none',
                            boxShadow: '0 1px 4px rgba(79,162,205,0.08)'
                        }}
                    >
                        {this.state.stations.map(station => (
                            <option key={station.uid} value={station.uid} style={{ padding: '8px', fontSize: '15px' }}>
                                {station.naziv || station.uid}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ width: '95%', marginTop: '10px' }}>
                    <Bar data={graph1} height={300} width={600} options={options1} />
                </div>
            </div >
        );
    }
}